import { STATE_ENUM } from 'utils/constants/commonValues';

/* eslint-disable function-paren-newline */
function MerchantOnBoardStatusList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

MerchantOnBoardStatusList.prototype = Object.assign(
    MerchantOnBoardStatusList.prototype,
    {
        createTableData(tableData) {
            return (
                tableData &&
                tableData.userUpdateTrackingListList &&
                tableData.userUpdateTrackingListList.map(row =>
                    this.createRow(row)
                )
            );
        },
        createPaginationData(data) {
            if (data) {
                const { totalElements } = data;
                return {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    pageNumber: 0,
                    pageSize: 10,
                    sortingCriteria: '',
                    totalNumberOfPages: 0,
                    totalNumberOfRecords: totalElements,
                };
            }
            return {};
        },
        createRow(row) {
            const {
                entityCode,
                entityType,
                state,
                statusMessage,
                userId,
                category,
            } = row;
            return {
                entityCode,
                entityType,
                state: this.getState(state),
                statusMessage,
                userId,
                sectionType: category,
            };
        },
        getState(status) {
            if (!status) {
                return '-';
            }
            return STATE_ENUM[status];
        },
    }
);

export default MerchantOnBoardStatusList;
